import { gql } from "@apollo/client";
import { graphql } from "../gql";

// TODO: migrate to graphql
export const PROJECT_FIELDS = gql`
  fragment ProjectFields on Project {
    id
    name
    status
    createdAt
    updatedAt
    hideDatagameBranding
    hideSummaryPage
    showLeaderboard
    directory {
      id
    }
    leaderboardConfiguration {
      id
      nicknameQuestion
      nicknameQuestionColor
      header
      headerColor
      nicknameLabel
      numberOfPlayers
      showTimer
      subheader
      subheaderColor
      tableNicknameLabel
      tableScoreLabel
      tableTimeLabel
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
    }
  }
`;

export const VIDEO_FIELDS = gql`
  fragment VideoFields on Video {
    id
    name
    extension
    url
  }
`;

export const DIRECTORY_FRAGMENT = graphql(`
  fragment DIRECTORY_FIELDS on Directory {
    id
    name
    createdAt
    updatedAt
    default
  }
`);

export const PROJECT_FRAGMENT = graphql(`
  fragment PROJECT_FIELDS on Project {
    id
    name
    status
    createdAt
    updatedAt
    directory {
      id
      name
      createdAt
      updatedAt
      default
    }
  }
`);

export const USER_FRAGMANT = graphql(`
  fragment USER_FIELDS on User {
    id
    email
    firstName
    lastName
    role
    emailVerifiedAt
    createdAt
    updatedAt
  }
`);

export const LIBRARY_IMAGE_FIELDS = graphql(`
  fragment LIBRARY_IMAGE_FIELDS on LibraryImage {
    id
    name
    extension
    url
    organizationId
    createdAt
    updatedAt
    kind
    isGlobal
  }
`);

export const GAME_FIELDS = gql`
  fragment GameFields on Game {
    id
    name
    kind
    createdAt
    updatedAt
  }
`;

export const SWIPER_CONFIGURATION_FIELDS = gql`
  fragment SwiperConfigurationFields on SwiperConfiguration {
    id
    createdAt
    updatedAt
    shuffleCards
    showGameResults
    showWelcomePage
    question
    questionColor
    showFeedbackPage
    showButtons
    showLeaderboard
    showSwipeCorrectness
    correctSwipeText
    incorrectSwipeText
    likeText
    unlikeText
    leaderboardConfiguration {
      id
      nicknameQuestion
      nicknameQuestionColor
      header
      headerColor
      nicknameLabel
      numberOfPlayers
      showTimer
      subheader
      subheaderColor
      tableNicknameLabel
      tableScoreLabel
      tableTimeLabel
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
    }
  }
`;

export const TRIVIA_ANSWER_OPTION_FIELDS = gql`
  fragment TriviaAnswerOptionFields on TriviaAnswerOption {
    id
    createdAt
    updatedAt
    text
    isCorrect
    points
    explanation
  }
`;

export const TRIVIA_QUESTION_FIELDS = gql`
  ${TRIVIA_ANSWER_OPTION_FIELDS}
  ${VIDEO_FIELDS}
  fragment TriviaQuestionFields on TriviaQuestion {
    id
    createdAt
    updatedAt
    kind
    image {
      id
      name
      url
    }
    video {
      ...VideoFields
    }
    question
    timeToCompleteInSeconds
    options {
      ...TriviaAnswerOptionFields
    }
  }
`;

export const TRIVIA_CONFIGURATION_FIELDS = gql`
  ${TRIVIA_QUESTION_FIELDS}
  fragment TriviaConfigurationFields on TriviaConfiguration {
    id
    timeToCompleteInSeconds
    questions {
      ...TriviaQuestionFields
    }
    gameVisuals {
      id
      themeColor
      cardBackImage {
        id
        name
        url
      }
      showIcons
      iconSet
      backgroundColor
      backgroundPositiveColor
      backgroundNegativeColor
      positiveColor
      negativeColor
      backgroundImage {
        id
        name
        url
      }
    }
    showFeedbackPage
    showWelcomePage
    showLeaderboard
    welcomePage {
      id
      welcomeLine
      welcomeLineColor
      subheading
      subheadingColor
      tagLine
      tagLineColor
      button
      buttonColor
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
      logo {
        id
        name
        url
      }
    }
    feedbackPage {
      id
      title
      titleColor
      instructionLine
      instructionLineColor
      textBoxPrompt
      textBoxPromptColor
      submitButton
      submitButtonColor
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
    }
  }
`;

export const ATTRIBUTE_FIELDS = gql`
  fragment AttributeFields on Attribute {
    id
    name
    createdAt
    updatedAt
    customText
    points
    isCorrect
    showImageAndText
    customRatingQuestion {
      question
      leftLabel
      rightLabel
      scaleSize
    }
    image {
      id
      name
      url
    }
  }
`;

export const WORDLE_CONFIGURATION_FIELDS = gql`
  fragment WordleConfigurationFields on WordleConfiguration {
    id
    createdAt
    updatedAt
    word
    numberOfTries
    showWelcomePage
    showFeedbackPage
    showLeaderboard
    leaderboardConfiguration {
      id
      nicknameQuestion
      nicknameQuestionColor
      header
      headerColor
      nicknameLabel
      numberOfPlayers
      showTimer
      subheader
      subheaderColor
      tableNicknameLabel
      tableScoreLabel
      tableTimeLabel
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
    }
    gameVisuals {
      id
      themeColor
      cardBackImage {
        id
        name
        url
      }
      showIcons
      iconSet
      backgroundColor
      backgroundPositiveColor
      backgroundNegativeColor
      positiveColor
      negativeColor
      presentLetter
      correctLetter
      defaultLetter
      absentLetter
      backgroundImage {
        id
        name
        url
      }
    }
  }
`;
